module.exports = __webpack_public_path__ + "static/media/day-movement.252dd962.svg";